import React from "react"
import DateHelper from '../../DateHelper/DateHelper';
import clsx from "clsx"

export default class ReservationSettingPresenterGeneral extends React.Component {

	constructor(props) {
		super(props)
	}

	render() {
		var self = this;

		var tabClasses = clsx({
			'active': this.props.active_tab == 'reservation_settings',
			'tab-pane': true
		})
		var date_format = ""
		var time_format = ""

		Object.keys(self.props.date_formats).forEach(function(key, index) {
			if (self.props.date_formats[key] == self.props.date_format) {
				date_format = key
			}
		});

		Object.keys(self.props.time_formats).forEach(function(key, index) {
			if (self.props.time_formats[key] == self.props.time_format) {
				time_format = key
			}
		});
		return (
			<div className={tabClasses} id="reservation_settings">

				<div className="row">
					<div className="col-sm-6">
						<div className="form-group">
							<label style={{marginRight: "4px"}}>{I18n.t('check_in_time')}</label>
							<span className="ss-help help" title={I18n.t('default_check_in_time_helper_text')}></span>
							<br/>
							{/* {format(new Date(this.props.check_in_time), DateHelper.rubyToDateFNS(this.props.time_format) )} */}
							{this.props.check_in_time ? DateHelper.printDateToScreen(new Date(this.props.check_in_time), this.props.time_format, true) : null}
						</div>
					</div>

					<div className="col-sm-6">
						<div className="form-group">
							<label style={{marginRight: "4px"}}>{I18n.t('check_out_time')}</label>
							<span className="ss-help help" title={I18n.t('default_check_out_time_helper_text')}></span>
							<br/>
							{/* {format(new Date(this.props.check_out_time), DateHelper.rubyToDateFNS(this.props.time_format) )} */}
							{this.props.check_out_time ? DateHelper.printDateToScreen(new Date(this.props.check_out_time), this.props.time_format, true) : null}
						</div>
					</div>
				</div>

				<div className="row">

					<div className="col-sm-6">
						<div className="form-group">
							<label style={{marginRight: "4px"}}> {I18n.t('reservation_auto_assign')} </label>
							<span className="ss-help help" title={I18n.t("reservation_auto_assign_helper_text")}></span>
							<br/>
							{this.props.auto_assign ? "Yes" : "No"}
						</div>
					</div>

					<div className="col-sm-6">
						<div className="form-group">
							<label style={{marginRight: "4px"}}>{I18n.t('maximum_stay')}</label>
							<span className="ss-help help" title={I18n.t('maximum_stay_helper_text')}></span>
							<br/>
							{this.props.maximum_stay}
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-md-6">
						<div className="form-group">
							<label style={{marginRight: "4px"}}>{I18n.t("date_format")}</label>
              <span className="ss-help help" title={I18n.t("reservation_default_date_format_helper_text")}></span>
							<br/>
							{date_format}
						</div>
					</div>

					<div className="col-md-6">
						<div className="form-group">
							<label style={{marginRight: "4px"}}>  {I18n.t("time_format")} </label>
              <span className="ss-help help" title={I18n.t("reservation_default_time_format_helper_text")}></span>
							<br/>
							{time_format}
						</div>
					</div>
				</div>

				<div className="row">
         <div className="col-md">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t("default_check_in_date")}* <span className="ss-help help" title={I18n.t('default_check_in_date_helper_text')}></span></label>
              <br />
							{this.props.default_check_in_date}
            </div>
          </div>
          <div className="col-md">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t("default_number_of_nights")}* <span className="ss-help help" title={I18n.t('default_number_of_nights_helper_text')}></span></label>
              <br />
							{this.props.default_number_of_nights}
            </div>
          </div>
          <div className="col-md">
            <div className="form-group" style={{marginBottom: 0}}>
              <label>{I18n.t("booking_window_days")}*</label>
							<br />
              {this.props.booking_window_days}
            </div>
          </div>
        </div>
			</div>
		)
  }
}
